import React from 'react';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" style={{ 
      height: '70vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      padding: '6rem 6%',
      backgroundImage: 'url(https://images.unsplash.com/photo-1571794571480-29b0fba2d1be?q=80&w=3870&auto=format&fit=crop)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: 'white'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1
      }}></div>
      
      <div style={{ maxWidth: '800px', zIndex: 10, position: 'relative' }}>
        <h1 style={{ 
          fontSize: '3.5rem',
          marginBottom: '1.5rem',
          lineHeight: 1.2,
          color: '#fff',
          fontWeight: 700,
          textShadow: '0 2px 4px rgba(0,0,0,0.2)'
        }}>
          Legal Services for Startups
        </h1>
        <p style={{ 
          fontSize: '1.25rem',
          color: '#f0f0f0',
          marginBottom: '2.5rem',
          maxWidth: '650px',
          textShadow: '0 1px 2px rgba(0,0,0,0.2)'
        }}>
          Designed for fast-moving and ambitious startups.
        </p>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button 
            onClick={scrollToContact}
            style={{
              backgroundColor: '#fff',
              color: '#000',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '5px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
          >
            Book a Consultation →
          </button>
          
        </div>
      </div>
    </section>
  );
};

export default Hero; 